import React from 'react';

export function LoadingScreen() {
  return (
    <div className="max-w-2xl mx-auto p-6 bg-gray-50 min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Ładowanie słownictwa...</p>
      </div>
    </div>
  );
} 